<template>
  <div class="refund">
    <BaseTitle
      :text="title"
      size="l"
      is-up
      class="refund__title"
    />
    <BaseText
      :text="description"
      size="l"
      class="refund__text"
    />
    <BaseText
      :text="details"
      size="m"
      class="refund__text"
    />
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'Refund',
  components: {
    BaseTitle,
    BaseText,
  },
  props: {
    order: {
      type: Object,
      default: null,
    },
    tickets: {
      type: Number,
      default: 0,
    },
    sum: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    title() {
      return this.$t('titles.refundOrder', { id: this.order?.id });
    },
    description() {
      return this.$t('texts.refundDescription');
    },
    details() {
      const ticketsCount = this.$tc('pluralization.ticket', this.tickets);
      const sum = this.$t('texts.sum') + this.$options.filters.sum(this.sum, true);
      return `${ticketsCount}, ${sum}`;
    },
  },
};
</script>

<style lang="stylus">
.refund
  display block
  text-align center

  &__title
    margin-bottom 0.5em

  &__text
    margin-top 0.5em
</style>
